/**
 * Trial Banner Component
 * Subtle trial countdown banner for main pages
 */

import React from 'react';
import { useTrial } from '../contexts/TrialContext';
import { useOrganization } from '../contexts/OrganizationContext';
import { getTrialStatusColor } from '../utils/trialUtils';
import { useTranslation } from 'react-i18next';
import './TrialBanner.css';

const TrialBanner = () => {
  const { t } = useTranslation('account');
  const { 
    trialStatus, 
    daysRemaining, 
    isTrialExpired, 
    isOnTrial,
    hasActiveSubscription,
    loading 
  } = useTrial();
  
  const { userRole } = useOrganization();

  // Don't show if loading, has active subscription, or not on trial
  if (loading || hasActiveSubscription || !isOnTrial) {
    return null;
  }

  // Don't show for non-BusinessOwners (they can't upgrade anyway)
  if (userRole !== 'BusinessOwner') {
    return null;
  }

  // Get status color for subtle styling
  const statusColor = getTrialStatusColor(trialStatus?.trialStatus, daysRemaining);

  // Determine message based on trial status
  const getTrialMessage = () => {
    if (isTrialExpired) {
      return t('trial.expiredMessage');
    }
    
    if (daysRemaining <= 0) {
      return t('trial.expiredMessage');
    }
    
    if (daysRemaining === 1) {
      return t('trial.oneDayRemaining');
    }
    
    return `Free Trial: ${daysRemaining || 0} days remaining`;
  };

  return (
    <div className="trial-banner">
      <div className="trial-banner-content">
        <div className="trial-banner-indicator" style={{ backgroundColor: statusColor }} />
        <span className="trial-banner-text">
          {getTrialMessage()}
        </span>
      </div>
    </div>
  );
};

export default TrialBanner;
